const sharedInput = {
  params: '/espositori/matchmaking/user',
  customMethod: 'post',
};

export const listMatchMakingUsers = async ({ network, id }) =>
  await network.azureMatchmakingLambda({
    params: `/espositori/${id}/matchmaking/users`,
    customMethod: 'get',
    data: {},
    federationId: id,
  });

export const listMatchMakingReports = async ({ network, id }) =>
  await network.azureMatchmakingLambda({
    params: `/espositori/${id}/matchmaking/report`,
    customMethod: 'get',
    data: {},
    federationId: id,
  });

export const createMatchMakingUser = async ({
  network,
  id,
  data = {
    lastName: '',
    ragioneSociale: '',
    newPassword: '',
  },
}) => {
  const { lastName, ragioneSociale, newPassword } = data;
  const input = {
    ...sharedInput,
    data: {
      lastName,
      ragioneSociale,
      parentFederationId: id,
      userFederationId: '',
      newPassword,
      mode: 1,
    },
  };
  return await network.azureMatchmakingLambda({
    params: `/espositori/matchmaking/user`,
    customMethod: 'post',
    data: input,
    federationId: id,
  });
};

export const editPasswordMatchMakingUser = async ({
  network,
  id,
  data = {
    userFederationId: '',
    newPassword: '',
  },
}) => {
  const { userFederationId, newPassword } = data;
  const input = {
    ...sharedInput,
    data: {
      lastName: '',
      ragioneSociale: '',
      parentFederationId: '',
      userFederationId,
      newPassword,
      mode: 2,
    },
  };
  return await network.azureMatchmakingLambda({
    params: `/espositori/matchmaking/user`,
    customMethod: 'post',
    data: input,
    federationId: id,
  });
};

export const deactivateMatchMakingUser = async ({
  network,
  id,
  data = { userFederationId: '' },
}) => {
  const { userFederationId } = data;
  const input = {
    ...sharedInput,
    data: {
      lastName: '',
      ragioneSociale: '',
      parentFederationId: '',
      userFederationId,
      newPassword: '',
      mode: 3,
    },
  };
  return await network.azureMatchmakingLambda({
    params: `/espositori/matchmaking/user`,
    customMethod: 'post',
    data: input,
    federationId: id,
  });
};

export const TABS_ENUM = {
  REPORTS: 'reports',
  USERS: 'users',
  INTEGRATION: 'integration',
};

export const PROFILES_INFO = {
  // GOLD: {
  //   id: 'gold_profile',
  //   maxUsers: 50,
  //   iconColor: '#FFAE00',
  //   i18nLabel: 'gold',
  // },
  // SILVER: {
  //   id: 'silver_profile',
  //   maxUsers: 10,
  //   iconColor: '#777777',
  //   i18nLabel: 'silver',
  // },
  // BASIC: {
  //   id: 'basic_profile',
  //   maxUsers: 1,
  //   iconColor: '#F28C8C',
  //   i18nLabel: 'basic',
  // },
  PREMIUM: {
    id: 'premium_profile',
    i18nLabel: 'premium',
  },
  BASIC: {
    id: 'basic_profile',
    i18nLabel: 'basic',
  },
};

export const DIALOG_CONTEXT = {
  INFO: 'info',
  CREATE: 'create',
  EDIT: 'edit',
  DELETE: 'delete',
};

export const ASK_FOR = {
  GOLD: 'activateGold',
  SILVER: 'activateSilver',
};
